import SingleDatePicker from "components/input-range-data";
import { useFilterEngineAction } from "../../duck/hook/action";
import { useFilterEngineHistoryState } from "../../duck/hook/state";

type FilterKeys =
  | "search"
  | "type_request"
  | "type_solicitation"
  | "created_at"
  | "meta";

export default function SelectFilters() {
  const filterState = useFilterEngineHistoryState();
  const { updateFilter } = useFilterEngineAction();

  const handleFilterChange = (key: FilterKeys, value: string | Date | null) => {
    if (key === "created_at" && value instanceof Date) {
      const localDate = new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate()
      );

      const yyyy = localDate.getFullYear();
      const mm = String(localDate.getMonth() + 1).padStart(2, "0");
      const dd = String(localDate.getDate()).padStart(2, "0");

      const formattedDate = `${yyyy}-${mm}-${dd}`;

      updateFilter(key, formattedDate);
    } else {
      updateFilter(key, value === "all" ? undefined : String(value));
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <div className="flex-1">
          <SingleDatePicker
            id="created-at"
            date={
              filterState.filters.created_at
                ? new Date(filterState.filters.created_at + "T00:00:00")
                : undefined
            }
            onDateChange={(date) =>
              handleFilterChange("created_at", date || "")
            }
          />
        </div>
      </div>
    </div>
  );
}
